import { render, staticRenderFns } from "./ReportPage.vue?vue&type=template&id=237f36a2&scoped=true"
import script from "./ReportPage.vue?vue&type=script&lang=js"
export * from "./ReportPage.vue?vue&type=script&lang=js"
import style0 from "./ReportPage.vue?vue&type=style&index=0&id=237f36a2&prod&scoped=true&lang=scss"
import style1 from "./ReportPage.vue?vue&type=style&index=1&id=237f36a2&prod&lang=css"
import style2 from "./ReportPage.vue?vue&type=style&index=2&id=237f36a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237f36a2",
  null
  
)

export default component.exports